import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';
import AlertNotification from '../components/Common/AlertNotification';
import Notification from '../components/Common/Notification';

const initialState = { 
   configListing: null,
   classListing: null,
   residenceListing: null,
   classOptions: null,
   residenceOptions: null,
   feesGroupListing: null,
   feesGroupOptions: null,
   feesVoteListing: null,
   batchListing: null,
   currentBatch: null,
   feesStructures: null,
   loading: false,
   alert: null
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const SchoolContext = createContext();

export const SchoolProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [notify, setNotify] = useState(null);
  const [showDeleteFeesGroup, setShowDeleteFeesGroup] = useState(false);
  
  useEffect(()=>{
    if(notify){
      setTimeout(() => {
        setNotify(null);
      }, 5000);
    }
  }, [notify])

  useEffect(()=>{
    buildClassOptions();
  }, [state.classListing])

  useEffect(()=>{
    buildResidenceOptions();
  }, [state.residenceListing])


  useEffect(()=>{
    buildFeesGroupOptions();
  }, [state.feesGroupListing])
 
  
  const getConfig = async (refresh) => {
    if(Array.isArray(state.configListing) && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchFeesConfig([]);
    if(server_response.status === "OK"){
      dispatch({ type: 'configListing', payload: server_response.details });
    }else{
      dispatch({ type: 'configListing', payload: '404' });
    }
  }

  const syncClasses = async ()=>{
    if(state.loading){
      return;
    }
    dispatch({type: 'alert', payload: <AlertNotification iconClass="fa fa-server" message="Synchronizing classes...please wait while operation completes." loader={true}/>})
    dispatch({type: 'loading', payload: true})
    const server_response = await ajaxSchool.syncClasses();
    dispatch({type: 'loading', payload: false})
    dispatch({type: 'alert', payload: null});
    if(server_response.status === "OK"){
      setNotify(<Notification message={server_response.message} type="success"/>)
    }else{
      setNotify(<Notification message={server_response.message} type="warning"/>)
    }
    await getClasses();
  }

  const getClasses = async (refresh)=>{
    if(Array.isArray(state.classListing) && !refresh){
      return;
    }
      const server_response = await ajaxSchool.fetchAllClasses();
      if(server_response.status === "OK"){
        dispatch({ type: 'classListing', payload: server_response.details });
      }else{
        dispatch({ type: 'classListing', payload: '404' });
      }
  }


  const buildClassOptions = ()=>{
    const options=[{title:"All Classes", value:"0"}];
    if(Array.isArray(state.classListing))
    {
      state.classListing.forEach((item)=>
        options.push({title:item.class_name, value:item.id})
        )
    }
    dispatch({ type: 'classOptions', payload: options });
  }


  const getResidences = async (refresh)=>{
    if(Array.isArray(state.residenceListing) && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchResidences();
    if(server_response.status === "OK"){
      dispatch({ type: 'residenceListing', payload: server_response.details });
    }else{
      dispatch({ type: 'residenceListing', payload: '404' });
    }
  }

  const buildResidenceOptions = ()=>{
    const options=[{title:"All Residences", value:"0"}];
    if(Array.isArray(state.residenceListing))
    {
      state.residenceListing.forEach((item)=>
        options.push({title:item.residence_name, value:item.id})
        )
    }
    dispatch({ type: 'residenceOptions', payload: options });
  }


  const syncResidences = async ()=>{
    if(state.loading){
      return;
    }
    dispatch({type: 'alert', payload: <AlertNotification iconClass="fa fa-server" message="Synchronizing residences...please wait while operation completes." loader={true}/>})
    dispatch({type: 'loading', payload: true})
    const server_response = await ajaxSchool.syncResidence();
    dispatch({type: 'loading', payload: false})
    dispatch({type: 'alert', payload: null});
    if(server_response.status === "OK"){
      setNotify(<Notification message={server_response.message} type="success"/>)
    }else{
      setNotify(<Notification message={server_response.message} type="warning"/>)
    }
    await getResidences();
  }

  const syncStudents = async (classId, flag)=>{
    if(state.loading){
      return;
    }
    dispatch({type: 'alert', payload: <AlertNotification iconClass="fa fa-server" message="Synchronizing students...please wait while operation completes." loader={true}/>})
    dispatch({type: 'loading', payload: true})
    const server_response = await ajaxSchool.syncStudents(classId, flag);
    dispatch({type: 'loading', payload: false})
    dispatch({type: 'alert', payload: null});
    if(server_response.status === "OK"){
      setNotify(<Notification message={server_response.message} type="success"/>)
    }else{
      setNotify(<Notification message={server_response.message} type="warning"/>)
    }
  }


  const getFeesGroups = async (refresh)=>{
    if(Array.isArray(state.feesGroupListing) && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchFeesGroups();
    if(server_response.status === "OK"){
      dispatch({ type: 'feesGroupListing', payload: server_response.details });
    }else{
      dispatch({ type: 'feesGroupListing', payload: '404' });
    }
  }

  const buildFeesGroupOptions = ()=>{
    const options=[{title:"All Fees Groups", value:"0"}];
    if(Array.isArray(state.feesGroupListing))
    {
      state.feesGroupListing.forEach((item)=>
        options.push({title:item.group_name, value:item.id})
        )
    }
    dispatch({ type: 'feesGroupOptions', payload: options });
  }


  const getFeesVotes = async (refresh)=>{
    if(Array.isArray(state.feesVoteListing) && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchFeesVotes();
    if(server_response.status === "OK"){
      dispatch({ type: 'feesVoteListing', payload: server_response.details });
    }else{
      dispatch({ type: 'feesVoteListing', payload: '404' });
    }
  }

  const getBatchListing = async (refresh)=>{
    if(Array.isArray(state.batchListing) && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchBiillingBatches();
    if(server_response.status === "OK"){
      dispatch({ type: 'batchListing', payload: server_response.details });
    }else{
      dispatch({ type: 'batchListing', payload: '404' });
    }
  }

  const getCurrentBatch = async (refresh)=>{
    if(state.currentBatch && !refresh){
      return;
    }
    const server_response = await ajaxSchool.getCurrentBatch();
    if(server_response.status === "OK"){
      dispatch({ type: 'currentBatch', payload: server_response.details });
    }
  }

  const getFeesStructures = async (refresh)=>{
    if(state.feesStructures && !refresh){
      return;
    }
    const server_response = await ajaxSchool.fetchFeesGroupStructure();
    if(server_response.status === "OK"){
      dispatch({ type: 'feesStructures', payload: server_response.details });
    }else{
      dispatch({ type: 'feesStructures', payload: '404' });
    }
  }


  return(
    <SchoolContext.Provider value={{
      ...state,
      notify,
      showDeleteFeesGroup, 
      dispatch, 
      getConfig,
      syncClasses,
      syncResidences,
      getClasses,
      getResidences,
      syncStudents,
      getFeesGroups,
      getFeesVotes,
      getBatchListing,
      getCurrentBatch,
      getFeesStructures,
      setNotify,
      setShowDeleteFeesGroup
      }}>
      {children}
    </SchoolContext.Provider>
  )

}

export const useSchool = ()=>useContext(SchoolContext);

